import HTMLReactParser from "html-react-parser"
import React from "react"

import RichText from "./richText/Parser"

export default function Iconetextecitationimage({ component }) {
  const {
    media,
    richtitle,
    listItems,
    backgroundColor,
    imageOnRight,
  } = component

  return (
    <div
      className={`relative overflow-hidden ${
        backgroundColor === "blue" ? "bg-charlestonGreen-100 z-10" : ""
      }`}
    >
      <div className=" py-24 ">
        <div className="lg:mx-auto lg:max-w-7xl  px-4 sm:px-6 lg:px-8 lg:flex lg:gap-12">
          <div className="w-full lg:w-3/5 mx-auto lg:max-w-none lg:mx-0 lg:px-0 ">
            <div className="">
              <div className="pb-6 lg:pb-12">
                {richtitle && (
                  <RichText stringHtml={richtitle} option="heroTitle" />
                )}
              </div>

              {listItems?.length > 0 && (
                <ul className="px-8 grid grid-cols-1 gap-4 sm:grid-cols-2  sm:gap-12">
                  {listItems.map((i, key) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <li className="max-w-xs relative" key={key}>
                      <img
                        className="h-4 absolute left-[-30px] top-[5px]"
                        src="/checkIcon.png"
                        alt="Swizi"
                      />
                      <p>{HTMLReactParser(i.listItem)}</p>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
          {media && (
            <div
              className={`w-full lg:w-2/5 mt-12 sm:mt-16 lg:mt-0 ${
                imageOnRight ? "" : "order-first"
              }`}
            >
              <div className="lg:px-0 lg:m-0 lg:relative lg:h-full flex items-center ">
                <img
                  className={`w-full  lg:bottom-0 lg:absolute lg:w-auto lg:h-full  rounded lg:max-w-none ${
                    imageOnRight ? "lg:left-0" : "lg:right-0"
                  }`}
                  srcSet={
                    media?.localFile?.childImageSharp?.gatsbyImageData?.images
                      ?.sources[0]?.srcSet
                  }
                  alt={media.altText}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
